import { render, staticRenderFns } from "./DonutChart310.vue?vue&type=template&id=a72edea2&scoped=true"
import script from "./DonutChart310.vue?vue&type=script&lang=js"
export * from "./DonutChart310.vue?vue&type=script&lang=js"
import style0 from "./DonutChart310.vue?vue&type=style&index=0&id=a72edea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72edea2",
  null
  
)

export default component.exports